import { useState } from "react";
import { useTranslation } from "react-i18next";
import Icon from "../Icon/Icon";
import { cn } from "@/shared/utils/cn";

interface AlertProps {
  variant?: "Error";
  children?: React.ReactNode;
  disable?: boolean;
  title?: string;
  onClickClose?: () => void;
}

const iconVariant: any = {
  Error: "exclamation",
};

const Alert = ({
  children,
  variant = "Error",
  title,
  onClickClose,
  ...props
}: AlertProps) => {
  const [disable, setDisable] = useState(false);
  const { t } = useTranslation("", { keyPrefix: "alert" });
  const variantClassName = {
    Error: "bg-error-light",
  }[variant];

  return (
    <div
      className={cn(
        "items-center rounded-[1.25rem] px-[2rem] py-2 text-black shadow-[0px_0.4rem_0.5rem_0px_rgba(0,0,0,0.2)]",
        variantClassName,
        disable ? "hidden" : "flex"
      )}
      {...props}
    >
      <Icon className="h-10 w-10 fill-error" variants={iconVariant[variant]} />
      <div className="ml-[2rem]">
        <div className="font-semibold">{title || t("error")}</div>
        <div>{children}</div>
      </div>
      <div
        className="ml-auto flex cursor-pointer items-center"
        onClick={() => {
          setDisable(true);
          onClickClose && onClickClose();
        }}
      >
        <Icon className="w-6 fill-error" variants="times" />
      </div>
    </div>
  );
};
export default Alert;
